// baseurl.js

// Backend API base URL
export const baseurl = "https://subcity.evventoz.com/api/"; 

// Image base URL (for static uploads)
export const imgurl = "https://subcity.evventoz.com/"; 
